import React from 'react';

interface CurrencyTemplateProps {
  value: number | null | undefined;
}

/**
 * Formats a number as USD currency.
 */
export const CurrencyTemplate: React.FC<CurrencyTemplateProps> = ({ value }) => {
  return <span>${value?.toFixed(2) || '0.00'}</span>;
};

/** Syncfusion grid template wrapper - uses specified field or defaults to 'balance' */
export const currencyTemplate = (props: any, field: string = 'balance') => (
  <CurrencyTemplate value={props[field]} />
);

/** Pre-configured templates for common fields */
export const balanceTemplate = (props: any) => <CurrencyTemplate value={props.balance} />;
export const arBalanceTemplate = (props: any) => <CurrencyTemplate value={props.arBalance} />;

export default CurrencyTemplate;
